import { ComponentType } from '../typegen/component-type';
import { ReceiptPrintServerProps } from '../typegen/receipt-print-server-props';
import { UIConfig } from '../typegen/ui-config';

export function findReceiptPrintServerProps(config: UIConfig): ReceiptPrintServerProps | null {
	for (const page of config.pages) {
		if (!page.components) continue;
		for (const component of page.components) {
			if (component.type === ComponentType.ReceiptPrint) {
				return component.data?.receiptPrintServerProps || null;
			}
		}
	}
	return null;
}
